import { render } from "./AddProducts.vue?vue&type=template&id=cffc598e&scoped=true"
const script = {}

import "./../../../assets/styles/admin/add.scss?vue&type=style&index=0&id=cffc598e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cffc598e"]])

export default __exports__